import { capitalizeText } from 'src/util/formatters/stringNormalizer';
import { round } from '../../../../../util/numbers/rounder';
import { toEchartData } from '../../../Simple/echarts/gradeDataProcessor';

export default function toEchartOption(resultadosGerais, theme, chartFontSize = 14, disabledLegends = [], highlitIndex) {  
  const echartData = toEchartData(resultadosGerais);
  const { data, legends } = echartData;
  /**
   * Refere-se a um sub-pergunta da pergunta do tipo grade
   */
  const lines = [...new Set(data.map((value) => value.label).reverse())];

  /**
   * Tratando os dados para ficar de forma reverse e ordenado de acordo com:
   * 1. linhas do gráfico
   * 2. legenda do gráfico
   */
  const seriesData = data.reverse()
    .sort((a, b) => {
      if (lines.indexOf(a.label) < lines.indexOf(b.label)) return -1;
      if (lines.indexOf(a.label) > lines.indexOf(b.label)) return 1;
      return 0;
    })
    .sort((a, b) => {
      if (legends.indexOf(a.name) < legends.indexOf(b.name)) return -1;
      if (legends.indexOf(a.name) > legends.indexOf(b.name)) return 1;
      return 0;
    });


  /**
   * Somando o valor numérico das linhas do gráfico para obter cálculo da porcentagem baseado em 100%
   */
  const totalsFromLine = {};
  lines.forEach(line => {
    const totalFromLine = seriesData
      .filter(value => value.label === line)
      .map(value => value.numeric)
      .reduce((a, b) => a + b, 0);

    totalsFromLine[line] = totalFromLine;
  });

  const legendData = legends.map((legend) => ({
    name: legend,
    icon: 'circle',
    enabled: true,
  }));

  const selectedLegends = {};
  const series = [];
  legends.forEach((legend, index) => {
    selectedLegends[legend] = !disabledLegends.includes(legend);
    /**
     * Recuperando valores apenas para a legenda do index desejado
     * value: é realizado o cálculo da porcentagem porque em grade múltipla os valores podem ultrapassar 100%,
     *        fazendo com que as barras não fiquem alinhadas, o round é feito para garantir que o valor não
     *        fique inferior aos 100% necessários para o alinhamento da barra.
     *        Para gráfico de grade simples esta modificação não gera side effect.
     * label: refere-se ao valor da porcentagem retornado pelo backend (no caso de grade múltipla ultrapassa 100%)
     */
    const valuesFromLine = seriesData
    .filter(value => value.name === legend)
    .map((value, valueIndex) => {
      const result = round((value.numeric / totalsFromLine[value.label]) * 100, 1)
      return {
        value: result === 0 ? '' : result,
        label: result === 0 ? '' : value.value,
        name: value.name,
        numeric: value.numeric,
      }
    });

    /**
     * As séries são criadas de acordo com a legenda
     * o formatter da serie foi alterado para utilizar params.data.label
     * definido na linha 58 de forma a exibir o valor retornado pelo backend
     * e não o valor da porcentagem da barra em si (em casos de grade múltipla).
     * Para gráfico de grade simples esta modificação não gera side effect.
     */
    series.push({
      name: legend,
      type: 'bar',
      stack: 'total',
      label: {
        show: true,
        textStyle: {
          fontSize: chartFontSize,
          color: theme.label.text,
        },
        formatter: (params) => (`${round(params.data.label, 1)}%`),
      },
      ...(highlitIndex === undefined ? {} : {
        itemStyle: index === highlitIndex ? {
          borderType: theme.highlitedItemBorderType,
          borderColor: theme.highlitedItemBorderColor,
          borderWidth: theme.highlitedItemBorderWidth,
        } : null,
      }),
      data: valuesFromLine,
    });
  });

  const tooltipFormatter = (stackItens) => {
    const first = stackItens[0];
    const output = stackItens
      .map((item) => `${item.marker} ${item.seriesName}: ${item.data.numeric} (${item.data.label}%)`)
      .reduce((reduced, next) => reduced.concat('<br>').concat(next));
    const title = lines[first.dataIndex];
    return `${title}<br>${output}`;
  };

  return {
    color: theme.colors,
    animationDuration: 0,
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow',
      },
      formatter: tooltipFormatter,
    },
    legend: {
      data: legendData,
      selected: selectedLegends,
      icon: 'circle',
      top: '-1%',
      type: 'scroll',
      textStyle: {
        color: theme.legend.color,
        fontSize: chartFontSize,
        fontFamily: 'Roboto, sans-serif'
      },
      formatter: capitalizeText,
      pageTextStyle: {
        color: theme.legend.pagination.text.color,
      },
      pageIconColor: theme.legend.pagination.buttons.color,
    },
    grid: {
      left: '3%',
      right: '15%',
      bottom: '3%',
      containLabel: true,
    },
    xAxis: {
      type: 'value',
      data: legends,
      axisLabel: {
        show: false
      },
    },
    yAxis: {
      type: 'category',
      axisLabel: {
        textStyle: {
          color: theme.axis.x.label,
        },
      },
      axisLine: {
        lineStyle: {
          color: theme.axis.x.line,
        },
      },
      data: lines,
    },
    series,
  };
}
